import React, { useEffect, useState } from 'react';
import BroadcastSubscription from './BroadcastSubscription';
import { 
  Alert
} from '@cloudscape-design/components';
import { submissionsApi } from '../../../api/Submission';
import { parseAiRecommendationPercentageScore } from '../../../common/utility';

const BroadcastSubscriptionAdapter = ({ submissionId }) => {
  const [initialData, setInitialData] = useState({
    score: 0,
    recommendations: []
  });
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAgentRecommendations = async () => {
      if (!submissionId) return;
      
      setIsLoading(true);
      try {
        const recommendationsData = await submissionsApi.getLatestAgentSubmissionRecommendations(submissionId);
        
        if (recommendationsData) {
          setInitialData({
            score: parseAiRecommendationPercentageScore(recommendationsData.score) || 0,
            recommendations: recommendationsData.details?.recommendations || []
          });
        }
      } catch (err) {
        if (err.response?.status === 404) {
          setInitialData({
            score: 0,
            recommendations: []
          });
        } else {
          console.error('Error fetching agent recommendations:', err);
          setError(err.message);
        }
      } finally {
        setIsLoading(false);
      }
    };

    fetchAgentRecommendations();
  }, [submissionId]);

  if (isLoading) {
    return (
      <Alert type="success">
        Loading existing recommendations...
      </Alert>
    );
  }

  if (error) {
    return (
     <Alert type="warning">
      Error loading recommendations. Please try again later.
      </Alert>
    );
  }

  return (
    <BroadcastSubscription 
      topicId={submissionId}
      initialScore={parseAiRecommendationPercentageScore(initialData.score)}
      initialRecommendations={initialData.recommendations}
    />
  );
};

export default BroadcastSubscriptionAdapter;
